import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const aboutApi = createApi({
  reducerPath: "aboutApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_API}about`,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAbout: builder.query({
      query: () => ({
        url: "",
        method: "GET",
      }),
    }),
    getBranches: builder.query({
      query: () => ({
        url: "/branche",
        method: "GET",
      }),
    }),
  }),
});
export const { useGetAboutQuery , useGetBranchesQuery } = aboutApi;